module.exports = __webpack_public_path__ + "static/media/skyscraper-bg.5f4cae9c.jpg";